export default __webpack_public_path__ + "static/media/about4.e65d0935.jpeg";